import { API } from './config-service.api';
import { ICoverage, ICoveragePayload, ICoverageUpdatePayload } from '../interfaces/coverage.interface';

const PATH = '/coverages';

export const getCoverages = (keyName: string): Promise<{ data: ICoverage[] }> => API.get(PATH, { params: { keyName } });

export const createCoverage = (payload: ICoveragePayload): Promise<{ data: ICoverage }> => API.post(PATH, payload);

export const updateCoverage = (id: string, payload: ICoverageUpdatePayload): Promise<{ data: ICoverage }> => API.patch(`${PATH}/${id}`, payload);

export const deleteCoverage = (id: string): Promise<any> => API.delete(`${PATH}/${id}`);
